var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form-item', {
    attrs: {
      "label": "onSubFormRowDelete",
      "label-width": "150px"
    }
  }, [_c('el-button', {
    class: [_vm.eventHandled ? 'button-text-highlight' : ''],
    attrs: {
      "type": "info",
      "icon": "el-icon-edit",
      "plain": "",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.editEventHandler('onSubFormRowDelete', _vm.eventParams)
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.i18nt('designer.setting.addEventHandler')))])], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51ad4ad8","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/setting-panel/property-editor/event-handler/onSubFormRowDelete-editor.vue
// module id = null
// module chunks = 